import React from 'react'

const NavigationDots = ({active}) => {
  return (
    <div className='app__navigation'>
       {['home','about','services','why-choose','featured-projects', 'programmes', 'faquestions','stacks','testimonial', 'contact'].map((item , index) =>(
            <a  
                href={`#${item}`} 
                key={item + index}
                className='app__navigation-dot'
                style={active === item ? {backgroundColor: '#008080'} : {}}

            />
               
        ))}
    </div>
  )
}

export default NavigationDots